import React from 'react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
interface TrustStripProps {
  tone?: 'light' | 'dark';
  className?: string;
}
const items = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function TrustStrip({
  tone = 'light',
  className = ''
}: TrustStripProps) {
  const color = tone === 'dark' ? 'text-cream-300' : 'text-ink-600';
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 font-sans text-xs sm:gap-x-6 sm:gap-y-2 sm:text-sm ${color} ${className}`} data-id="element-184" data-mp="25c05fiaphgq6">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-185" data-mp="1wezjdib3zupw">
          <Icon className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-186" data-mp="3uq582q3svgl9" />
          {label}
        </li>)}
    </ul>;
}